const API = "/api/v1";

export async function adminClient(path, { method = "GET", body, signal } = {}) {
  const response = await fetch(API + path, {
    method,
    credentials: "include",
    signal,
    headers:
      body === undefined ? undefined : { "Content-Type": "application/json" },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok)
    throw new Error(payload.error || `Request failed (${response.status})`);
  return payload;
}

export function auditQuery(filters) {
  const params = new URLSearchParams();
  for (const key of ["q", "action", "organisation_id", "actor_id", "limit", "offset", "paged"]) {
    if (filters[key] !== undefined && filters[key] !== "")
      params.set(key, String(filters[key]));
  }
  for (const key of ["from", "to"]) {
    if (!filters[key]) continue;
    // datetime-local has no offset; these explicitly labelled audit controls
    // use UTC, so browser timezone and daylight-saving folds cannot shift them.
    const value = String(filters[key]);
    const date = new Date(value.endsWith("Z") ? value : `${value}Z`);
    if (!Number.isFinite(date.getTime()))
      throw new Error(`Invalid ${key} audit date`);
    params.set(key, date.toISOString());
  }
  return params.toString();
}

export function formatAdminDate(value) {
  if (!value) return "—";
  const date = new Date(value);
  return Number.isFinite(date.getTime())
    ? date.toLocaleString("en-GB", { dateStyle: "medium", timeStyle: "short" })
    : "—";
}
